import { combineReducers } from "redux"
import { analyticsReducer } from "~Shared/store/reducers/analyticsReducer"
import { authReducer } from "~Shared/store/reducers/authReducer"
import { bankReducer } from "~Shared/store/reducers/bankReducer"
import { companyReducer } from "~Shared/store/reducers/companyReducer"
import { corporateReducer } from "~Shared/store/reducers/corporateReducer"
import { costCenter2Reducer } from "~Shared/store/reducers/costCenter2Reducer"
import { costCenterReducer } from "~Shared/store/reducers/costCenterReducer"
import { creditCardReducer } from "~Shared/store/reducers/creditCardReducer"
import { csvTemplateReducer } from "~Shared/store/reducers/csvTemplateReducer"
import { currencyReducer } from "~Shared/store/reducers/currencyReducer"
import { employeeReducer } from "~Shared/store/reducers/employeeReducer"
import { expenseAccountReducer } from "~Shared/store/reducers/expenseAccountReducer"
import { expenseReducer } from "~Shared/store/reducers/expenseReducer"
import { expenseTagReducer } from "~Shared/store/reducers/expenseTagReducer"
import { featureFlagsReducer } from "~Shared/store/reducers/featureFlagsReducer"
import { fetcherReducer } from "~Shared/store/reducers/fetcherReducer"
import { importReducer } from "~Shared/store/reducers/importReducer"
import { inboxInvoiceReducer } from "~Shared/store/reducers/inboxInvoiceReducer"
import { liquidityReducer } from "~Shared/store/reducers/liquidityReducer"
import { perDiemDestinationReducer } from "~Shared/store/reducers/perDiemDestinationReducer"
import { roleReducer } from "~Shared/store/reducers/roleReducer"
import { tableConfigReducer } from "~Shared/store/reducers/tableConfigReducer"
import { tableReducer } from "~Shared/store/reducers/tableReducer"
import { taxReducer } from "~Shared/store/reducers/taxReducer"
import { teamReducer } from "~Shared/store/reducers/teamReducer"
import { transactionCategoryReducer } from "~Shared/store/reducers/transactionCategoryReducer"
import { transactionReducer } from "~Shared/store/reducers/transactionReducer"
import { workflowReducer } from "~Shared/store/reducers/workflowReducer"
import { AuthActionTypes } from "../actions/auth/authTypes"
import { type RootState } from "../rootState.interface"

const appReducer = combineReducers<RootState>({
    auth: authReducer,
    employees: employeeReducer,
    expenses: expenseReducer,
    inboxInvoices: inboxInvoiceReducer,
    costCenters: costCenterReducer,
    costCenters2: costCenter2Reducer,
    fetcher: fetcherReducer,
    company: companyReducer,
    currency: currencyReducer,
    banks: bankReducer,
    expenseAccounts: expenseAccountReducer,
    analytics: analyticsReducer,
    transactions: transactionReducer,
    transactionCategories: transactionCategoryReducer,
    creditCards: creditCardReducer,
    corporate: corporateReducer,
    tableConfig: tableConfigReducer,
    taxes: taxReducer,
    teams: teamReducer,
    tables: tableReducer,
    workflows: workflowReducer,
    liquidity: liquidityReducer,
    featureFlags: featureFlagsReducer,
    imports: importReducer,
    roles: roleReducer,
    expenseTags: expenseTagReducer,
    perDiemDestinations: perDiemDestinationReducer,
    csvTemplates: csvTemplateReducer,
})

export const rootReducer = (state: any, action: any) => {
    if (action.type === AuthActionTypes.RESET_REDUX_STORE) {
        // Undefined results in the state being reset to the initial state
        return appReducer(undefined, action)
    }
    return appReducer(state, action)
}
